import { useApp } from "@/lib/AppContext";

const T = {
  ar: {
    badge: "لماذا نحن؟",
    title: "مميزات تجعلنا الأفضل",
    features: [
      { icon: "🚗", title: "استلام وتوصيل مجاني", desc: "نصل إلى بابك في أسرع وقت دون أي رسوم إضافية" },
      { icon: "⏱️", title: "جاهز خلال 18 ساعة", desc: "خدمة سريعة تضمن وصول ملابسك في الوقت المحدد" },
      { icon: "🧴", title: "منظفات فاخرة آمنة", desc: "نستخدم أفضل المنظفات المعتمدة الآمنة للملابس والبشرة" },
      { icon: "📱", title: "تتبع طلبك لحظة بلحظة", desc: "راقب حالة طلبك في أي وقت من خلال تطبيقنا" },
      { icon: "💰", title: "أسعار تنافسية", desc: "جودة عالية بأسعار في متناول الجميع مع عروض مستمرة" },
      { icon: "🌟", title: "ضمان جودة التنظيف", desc: "نضمن نظافة ملابسك أو نعيد تنظيفها مجاناً" },
    ]
  },
  en: {
    badge: "Why Choose Us?",
    title: "Features That Make Us the Best",
    features: [
      { icon: "🚗", title: "Free Pickup & Delivery", desc: "We come to your door at no extra charge" },
      { icon: "⏱️", title: "Ready in 18 Hours", desc: "Fast service guarantees your clothes are returned on time" },
      { icon: "🧴", title: "Premium Safe Detergents", desc: "We use the best certified detergents, safe for clothes and skin" },
      { icon: "📱", title: "Real-Time Tracking", desc: "Monitor your order status anytime through our app" },
      { icon: "💰", title: "Competitive Prices", desc: "High quality at affordable prices with ongoing offers" },
      { icon: "🌟", title: "Quality Guarantee", desc: "We guarantee clean clothes or we re-clean them for free" },
    ]
  }
};

export default function FeaturesSection() {
  const { lang } = useApp();
  const tr = T[lang] || T.ar;
  const isAr = lang === "ar";

  return (
    <section id="features" className="py-20 bg-background" dir={isAr ? "rtl" : "ltr"}>
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <span className="inline-block bg-primary/10 text-primary text-xs font-black px-4 py-2 rounded-full mb-3">
            {tr.badge}
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-foreground">{tr.title}</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {tr.features.map((f, i) => (
            <div key={i}
              className="group bg-card border border-border rounded-2xl p-5 hover:border-primary/40 hover:shadow-lg hover:shadow-primary/5 transition-all duration-300 hover:-translate-y-1">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-12 h-12 shrink-0 bg-primary/10 rounded-2xl flex items-center justify-center text-2xl group-hover:bg-primary/20 transition-all">
                  {f.icon}
                </div>
                <h3 className="font-black text-foreground text-base lg:text-lg leading-tight">{f.title}</h3>
              </div>
              <p className="text-muted-foreground text-sm leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}